import { middleSidePartOfWeb2, topSidePartOfWeb2 } from './parts/sideParts'
import { verticalPartsOfWebWithCenterStitch } from './parts/verticalParts'

export const w31Web = async (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ_縦
  await verticalPartsOfWebWithCenterStitch(ctx, webColor2 || webColor, stitchColor, printLeatherTypeValue)
  // ウェブ先端
  await topSidePartOfWeb2(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  // ウェブ_横＿中間
  await middleSidePartOfWeb2(ctx, webColor, stitchColor, 5, 10, printLeatherTypeValue)
}
